export const MarkerConstants = {
  POPULATE_MARKERS: 'LOAD_MARKERS_FROM_CHRONICLE',

  FETCH_CHRONICLE_MARKERS_REQUEST: 'FETCH_MARKERS_BY_CHRONICLE_REQUEST',
  FETCH_CHRONICLE_MARKERS_SUCCESS: 'FETCH_MARKERS_BY_CHRONICLE_SUCCESS',
  FETCH_CHRONICLE_MARKERS_FAILURE: 'FETCH_MARKERS_BY_CHRONICLE_FAILURE',

  FETCH_MAP_MARKERS_REQUEST: 'FETCH_MARKERS_BY_MAP_REQUEST',
  FETCH_MAP_MARKERS_SUCCESS: 'FETCH_MARKERS_BY_MAP_SUCCESS',
  FETCH_MAP_MARKERS_FAILURE: 'FETCH_MARKERS_BY_MAP_FAILURE',

  CREATE_MARKER_REQUEST: 'CREATE_MARKER_REQUEST',
  CREATE_MARKER_SUCCESS: 'CREATE_MARKER_SUCCESS',
  CREATE_MARKER_FAILURE: 'CREATE_MARKER_FAILURE',

  UPDATE_MARKER_REQUEST: 'UPDATE_MARKER_REQUEST',
  UPDATE_MARKER_SUCCESS: 'UPDATE_MARKER_SUCCESS',
  UPDATE_MARKER_FAILURE: 'UPDATE_MARKER_FAILURE',

  DELETE_MARKER_REQUEST: 'DELETE_MARKER_REQUEST',
  DELETE_MARKER_SUCCESS: 'DELETE_MARKER_SUCCESS',
  DELETE_MARKER_FAILURE: 'DELETE_MARKER_FAILURE',

  FETCH_MARKER_TYPES_REQUEST: 'FETCH_MARKER_TYPES_REQUEST',
  FETCH_MARKER_TYPES_SUCCESS: 'FETCH_MARKER_TYPES_SUCCESS',
  FETCH_MARKER_TYPES_FAILURE: 'FETCH_MARKER_TYPES_FAILURE',

  UPDATE_MAKRERS_MAP_DELETE: 'UPDATE_MARKERS_ON_MAP_DELETE',
};
